import { render, staticRenderFns } from "./DiagramPreviewer.vue?vue&type=template&id=0519ce80"
import script from "./DiagramPreviewer.vue?vue&type=script&lang=js"
export * from "./DiagramPreviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports